import { render, staticRenderFns } from "./GWSocial.vue?vue&type=template&id=11fdd348&scoped=true"
var script = {}
import style0 from "./GWSocial.vue?vue&type=style&index=0&id=11fdd348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fdd348",
  null
  
)

export default component.exports